<template>
  <div class="cause-contain">
    <div class="title">{{ title }}</div>
    <div class="content">
      <div
        class="list line_bottom_span"
        v-for="(item, index) in caseList"
        :key="index"
        @click="checkFile(item.fileUrl, item.fileName)"
      >
        <div class="edge">
          <div class="pic">
            <img
              class="picimg"
              v-if="item.fileType == 'pdf'  || item.fileType == 'application/pdf' "
              src="../../../../assets/appraise/ic_pdf.png"
            />
            <img
              class="picimg"
              v-if="item.fileType == 'doc'   || item.fileType == 'application/doc'  "
              src="../../../../assets/appraise/ic_doc.png"
            />
            <img
              class="picimg"
              v-if="item.fileType == 'exl'  || item.fileType == 'application/exl' "
              src="../../../../assets/appraise/ic_exl.png"
            />
          </div>
          <div class="text">
            <span class="textspan">{{ item.fileName }}.{{ item.fileType }}</span>
            <div class="tagbox">
              <!-- <txtTag
                class="tag"
                :bgColor="'#fff'"
                :border="'#36B374'"
                :txtColor="'#36B374'"
              >上的飞机啊撒发达的说法啊手动阀</txtTag> -->
               <div class="tag">{{ item.fileKindCN}}</div>
              </div>
              <!-- <div class="tag">{{ item.fileKindCN}}</div> -->
          </div>
          <div class="size">{{ item.fileSize}}</div>
        </div>
      </div>
    </div>
    <modalIframe :url="iframeurl"></modalIframe>
  </div>
</template>

<script>
import txtTag from "../../components/txt-tag";
import modalIframe from './modalIframe';
export default {
  name: "materialScience",
  props: {
    caseList: { type: Array },
    title: { type: String },
  },
  components: {
    txtTag,
    modalIframe
  },
  data() {
    return {
      // maxWidth: '24px'
       iframeurl:''
    };
  },
  methods: {
    checkFile(url, name) {
      const _this = this;
      //  this.$router.push({ path: "/appraise/iframepdf", query: { url: url } });
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓---测试隐藏的iframe--进来这里url:", url);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
        // this.$router.push({ path: "/appraise/iframepdf", query: { url: url } });
        this.iframeurl = url;
      } else {
        console.log('---ios的url:', url);
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: url,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1,
          },
          (cb) => {
            console.log(cb, "callback");
          }
        );
      }
      setTimeout( ()=>{
        _this.iframeurl = ''
      }, 100)
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.cause-contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-top: 24px;
  }

  .content {
    margin-top: 12px;
    .list {
      .edge {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .text {
          flex: 1;
          padding-right: 32px;
          margin-left: 12px;
          min-height: 38px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .textspan {
            display: inline-block;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 22px;
            padding: 0;
            margin: 0;
            color: rgba(51, 51, 51, 1);
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .tagbox {
            width: 100%;
            height: 14px;
            display: flex;
            margin-top: 8px;
            align-items: center;
            // transform: scale(0.5);
            transform-origin: left 0;
          }
        }

        .pic {
          width: 34px;
          height: 38px;
          margin-top: 2px;
          .picimg {
            width: 100%;
            height: 100%;
          }
        }
        .size {
          font-size: 12px;
          height: 38px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 38px;
        }
      }
    }

    // .line_bottom:last-child::after {
    //   background: none;
    // }
    // .line_bottom:first-child::after {
    //   background: none;
    // }
    .line_bottom_span:last-child::after {
      border: none;
      background: none;
    }
    .line_bottom_span {
      margin-bottom: 16px;
      border: none;
      background: none;
    }
  }
  .tag {
    padding: 2px 4px;
    font-size: 10px;
    color: #36B374;
    border: 1px solid #36B374;
  }
}
</style>
